import { AppointmentGroupingResponse } from 'generated';
import { useTranslation } from 'react-i18next';

import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { dialogActiveAtom } from '../../atoms';

type Props = {
  employeeName?: string;
  employeeTypeName?: string | undefined;
  appointmentGrouping?: AppointmentGroupingResponse;
  planningFeatures?: string[] | null;
  onMouseOver?: () => void;
};

function ToolTipList({ values = [] }: { values: string[] }) {
  return (
    <ul
      style={{
        listStyleType: 'none'
      }}
    >
      {values.map((value, idx) => (
        <li key={idx}>{value}</li>
      ))}
    </ul>
  );
}

export default function ScheduleTooltipBody({
  employeeName,
  employeeTypeName,
  appointmentGrouping,
  planningFeatures,
  onMouseOver
}: Props) {
  const { t } = useTranslation('common');
  const dialogActive = useRecoilValue(dialogActiveAtom);

  if (dialogActive) return null;

  return (
    <Table
      onMouseOver={onMouseOver}
      size="small"
      sx={{
        'tr:last-child td': { border: 0 },
        th: { fontFamily: 'SourceSansPro-Regular' },
        'tr td:first-of-type': { fontFamily: 'SourceSansPro-Bold' }
      }}
    >
      <TableBody>
        {appointmentGrouping && (
          <TableRow>
            <TableCell colSpan={2}>{t('activityPlanning.route')}</TableCell>
            <TableCell>{appointmentGrouping.description}</TableCell>
          </TableRow>
        )}
        {employeeTypeName && (
          <TableRow>
            <TableCell colSpan={2}>{t('activityPlanning.expertise')}</TableCell>
            <TableCell>{employeeTypeName}</TableCell>
          </TableRow>
        )}
        {employeeName && (
          <TableRow>
            <TableCell colSpan={2}>{t('employee')}</TableCell>
            <TableCell>{employeeName}</TableCell>
          </TableRow>
        )}
        {planningFeatures && (
          <TableRow>
            <TableCell
              colSpan={2}
              sx={{
                verticalAlign: 'top'
              }}
            >
              Planningskenmerken
            </TableCell>

            <TableCell
              sx={{
                verticalAlign: 'top'
              }}
            >
              <ToolTipList values={planningFeatures} />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
